module.exports = __webpack_public_path__ + "img/timer_color_green.033ffbe1.svg";